import { Component, Input, Output, EventEmitter, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'lib-asset-list-pagination',
  templateUrl: './asset-list-pagination.component.html',
  styleUrls: ['./asset-list-pagination.component.scss'],
  standalone: false
})
export class AssetListPaginationComponent implements OnInit, OnChanges {

  constructor(private toastr: ToastrService) {}

  @Input() pageFromList: number = 0
  @Input() totalItems: number = 0;
  @Input() itemsPerPage: number = 10;
  @Output() pageChanged = new EventEmitter<number>();

  goToPageInput: number | null = null;
  currentPage: number = 1;
  totalPages: number = 0;
  pages: number[] = [];
  start: number = 0;
  end: number = 0;

  ngOnInit() {
    this.calculatePagination();
  }

  ngOnChanges(changes: SimpleChanges) {
  if (changes['totalItems'] || changes['itemsPerPage'] || changes['pageFromList']) {
    this.currentPage = this.pageFromList || 1; // Sinhronizuj currentPage sa pageFromList
    this.calculatePagination();
  }
}

goToPage(page: number) {
  if (page < 1 || page > this.totalPages || page === this.currentPage) {
    this.toastr.warning(`Please enter page between 1 and ${this.totalPages}`);
    return;
  }

  this.currentPage = page;
  this.calculatePagination();
  this.pageChanged.emit(this.currentPage);
}

  goToEnteredPage() {
    if (this.goToPageInput === null) return;
    const page = Number(this.goToPageInput);
    if (!Number.isInteger(page)) return;
    this.goToPage(page);
    this.goToPageInput = null;
  }

  private calculatePagination() {
    this.totalPages = Math.ceil(this.totalItems / this.itemsPerPage);

    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.totalItems);

    this.start = this.totalItems === 0 ? 0 : startIndex + 1;
    this.end = endIndex;

    this.pages = this.getVisiblePages(this.currentPage, this.totalPages);
  }

  private getVisiblePages(current: number, total: number, maxVisible: number = 5): number[] {
    const half = Math.floor(maxVisible / 2);
    let start = Math.max(current - half, 1);
    let end = Math.min(start + maxVisible - 1, total);

    if (end - start < maxVisible - 1) {
      start = Math.max(end - maxVisible + 1, 1);
    }

    const pages = [];
    for (let i = start; i <= end; i++) {
      pages.push(i);
    }
    return pages;
  }
}
